import React, { useEffect, useState } from "react";
import ComboAbmGeoPaises from "../../Combos/ComboAbmGeoPaises";
import ComboAbmGeoProvinciasEstados from "../../Combos/ComboAbmGeoProvinciasEstados";
import ComboAbmGeoCiudades from "../../Combos/ComboAbmGeoCiudades";

const LV_GEO = ({ IdPais, IdProvinciaEstado, IdCiudad, Ancho = 100, onChangePais, onChangeProvincia,
    onChangeCiudad, onChangePaisDescripcion, onChangeProvinciaDescripcion, onChangeCiudadDescripcion }) => {
    const [idPais, setIdPais] = useState(IdPais);
    const [idProvinciaEstado, setIdProvinciaEstado] = useState(IdProvinciaEstado);
    const [idCiudad, setIdCiudad] = useState(IdCiudad);
    const [reloadProvincias, setReloadProvincias] = useState(false);
    const [reloadCiudades, setReloadCiudades] = useState(false);
    const [descripcionPais, setDescripcionPais] = useState("");
    const [descripcionProvinciaEstado, setDescripcionProvinciaEstado] = useState("");
    const [descripcionCiudad, setDescripcionCiudad] = useState("");
    
    const handleOnValueChangedPais = (e) => {
        setIdPais(e.value)
        
        if (onChangePais) onChangePais(e.value);
    };

    const handleOnValueChangedProvinciaEstado = (e) => {
        setIdProvinciaEstado(e.value)
        
        if (onChangeProvincia) onChangeProvincia(e.value);
    };

    const handleOnValueChangedCiudad = (e) => {        
        setIdCiudad(e.value);
         
        if (onChangeCiudad) onChangeCiudad(e.value);
    };

    useEffect(() => {
        setIdPais(IdPais);
    }, [IdPais]);
    
    useEffect(() => {
        setIdProvinciaEstado(IdProvinciaEstado);
    }, [IdProvinciaEstado]);
    
    useEffect(() => {
        setIdCiudad(IdCiudad);
    }, [IdCiudad]);

    return (
        <div className="LV-GroupBox-div LV-FlexContainer">
            <ComboAbmGeoPaises
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                value={idPais}
                ancho={Ancho}
                onValueChanged={(e) => handleOnValueChangedPais(e)} />

            <ComboAbmGeoProvinciasEstados
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                value={idProvinciaEstado}
                onValueChanged={(e) => handleOnValueChangedProvinciaEstado(e)}
                ancho={Ancho}
                IdPais={idPais}
                reloadData={reloadProvincias} />

            <ComboAbmGeoCiudades
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                value={idCiudad}
                ancho={Ancho}
                onValueChanged={(e) => handleOnValueChangedCiudad(e)}
                IdProvinciaEstado={idProvinciaEstado}
                reloadData={reloadCiudades} />
        </div>
    );
};

export default LV_GEO;
